import '../../monitoring/filters/generic_user/generic_user_filter_view.js.coffee'

Namespace('Profiling.Dashboard.Filters')

class Profiling.Dashboard.Filters.GenericUserFilterView extends Monitoring.Views.SocialContents.Filters.GenericUserFilterView
  _triggerQueryChanged: => @searchQuery.triggerFilterChanged()
